/**
 * Template Redaction Flow Dialog Interfaces
 * Used for configuring redaction steps in document templates
 */

export interface TemplateRedactionNode {
    id: number;
    order: number;
    redaction_type: number; // 1 = Edit+Upload, 2 = Review/Approve
    user_type?: number; // functie_id
    user_id?: number;
    directie_id?: number;
    compartiment_id?: number;
    description?: string;

    // Display names (populated from backend or client-side lookup)
    functie_name?: string;
    user_name?: string;
    directie_name?: string;
    compartiment_name?: string;
}

export interface TemplateRedactionFlowData {
    template_id: number;
    template_name: string;
    redactions: TemplateRedactionNode[];
    total_steps: number;
}

export interface RedactionTypeInfo {
    icon: string;
    label: string;
    class: string;
}

export const REDACTION_TYPES: { [key: number]: RedactionTypeInfo } = {
    1: {
        icon: 'edit_document',
        label: 'Editare + Upload',
        class: 'redaction-type-edit'
    },
    2: {
        icon: 'fact_check',
        label: 'Review/Aprobare',
        class: 'redaction-type-review'
    }
};

/**
 * Request payload for adding a new redaction step
 */
export interface AddRedactionRequest {
    redaction_type: number;
    description?: string;
    user_type?: number;
    directie_id?: number;
    compartiment_id?: number;
    user_id?: number;
}

/**
 * Request payload for updating a redaction step
 */
export interface UpdateRedactionRequest {
    redaction_type?: number;
    description?: string;
    user_type?: number;
    directie_id?: number;
    compartiment_id?: number;
    user_id?: number;
}

/**
 * Request payload for reordering redaction steps
 */
export interface ReorderRedactionRequest {
    id: number;
    order: number;
}
